export default __webpack_public_path__ + "static/CookieRun-Regular-52560075f5d887966bf20aff673cef70.ttf";